<template>
  <div class="mt-2">
    <tecnician-only-message v-if="party.techniciansOnly" class="mb-2" />
    <v-expansion-panels focusable v-model="expansePanel" class="">
      <v-expansion-panel v-for="(ep, i) in expansionsPanels" :key="ep.name">
        <v-expansion-panel-header class="justify-start" disable-icon-rotate>
          <div class="d-flex align-center" style="gap: 1rem">
            <v-icon>{{ ep.icon }}</v-icon>
            <h6 class="mb-0">{{ ep.title }}</h6>
          </div>
          <template v-slot:actions>
            <v-btn small icon v-if="!!ep.saving" :loading="ep.saving.loading">
              <v-icon :color="ep.saving.error ? 'error' : 'success'">
                {{
                  ep.saving.error
                    ? "mdi-alert-circle"
                    : "mdi-content-save-check"
                }}
              </v-icon>
            </v-btn>
            <v-btn icon v-else-if="expansePanel !== i || expansePanel == null">
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
            <v-btn icon color="primary" v-else-if="ep.noSave || party.techniciansOnly && !user.MasterPermission">
              <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
            <v-btn icon color="primary" v-else>
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <component
            :is="ep.component"
            :party="party"
            :ref="ep.name"
          ></component>
          <div class="d-flex justify-end">
            <v-btn
              v-if="
                (!ep.noSave && !party.techniciansOnly) || user.MasterPermission
              "
              color="success"
              :loading="ep.saving.loading"
              :disabled="!!ep.saving"
              @click="saveGroup(i)"
            >
              {{ ep.saving ? "Salvo!" : "Salvar" }}
            </v-btn>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Basic from "./detailsComponents/Basic.vue";
import Location from "./detailsComponents/Location.vue";
import PartySlug from "./detailsComponents/PartySlug.vue";
import Multimedia from "./detailsComponents/Multimedia.vue";
import SubEvents from "./detailsComponents/SubEvents.vue";
import Analysis from "./detailsComponents/Analysis.vue";
import Document from "./detailsComponents/Document.vue";
import Effects from "./detailsComponents/Effects.vue";
import TecnicianOnlyMessage from "@/components/global/tecnician/TecnicianOnlyMessage.vue";
export default {
  components: {
    Basic,
    Location,
    PartySlug,
    Multimedia,
    SubEvents,
    Document,
    Analysis,
    Effects,
    TecnicianOnlyMessage,
  },
  data: () => ({
    loading: false,
    fileLoading: false,
    valid: false,
    error: false,
    expansePanel: 0,
    expansionsPanels: [
      {
        name: "basic",
        icon: "mdi-information",
        title: "Detalhes",
        component: "basic",
        saving: false,
      },
      {
        name: "location",
        icon: "mdi-map-marker",
        title: "Local",
        component: "location",
        saving: false,
      },
      {
        name: "multimedia",
        icon: "mdi-video",
        title: "Vídeo e Música",
        component: "Multimedia",
        saving: false,
      },
      {
        name: "document",
        icon: "mdi-file-document-arrow-right",
        title: "Documentos",
        component: "document",
        saving: false,
      },
      {
        name: "analysis",
        icon: "mdi-chart-line",
        title: "Análise de Dados",
        component: "analysis",
        saving: false,
      },
      {
        name: "slug",
        icon: "mdi-link",
        title: "Link",
        component: "PartySlug",
        saving: false,
      },
      {
        name: "subEvents",
        icon: "mdi-calendar",
        title: "Subeventos",
        component: "SubEvents",
        saving: false,
        noSave: true,
      },
      {
        name: "effects",
        icon: "mdi-lightning-bolt",
        title: "Efeitos",
        component: "Effects",
        saving: false,
      },
    ],
  }),
  methods: {
    async saveGroup(index) {
      try {
        if (this.expansionsPanels[index].noSave) return;
        if (this.party.techniciansOnly && !this.user.MasterPermission) return;
        this.expansionsPanels[index].saving = {
          loading: true,
          error: false,
        };

        const result = await this.$refs[
          this.expansionsPanels[index].name
        ][0].save();
        if (result === false) {
          this.expansionsPanels[index].saving = false;
          return;
        }

        this.expansionsPanels[index].saving = {
          loading: false,
          error: false,
        };

        this.$emit("refresh");
      } catch (e) {
        console.error(e);
        this.expansionsPanels[index].saving = {
          loading: false,
          error: true,
        };
      } finally {
        await new Promise((resolve) => setTimeout(resolve, 5000));
        this.expansionsPanels[index].saving = false;
      }
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  watch: {
    expansePanel(val, oldVal) {
      if (oldVal != undefined) this.saveGroup(oldVal);
      if (val != undefined) this.expansionsPanels[val].saving = false;
    },
  },
  mounted() {
    this.policies = Object.assign({}, this.party);
  },
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style></style>
